<template>
  <div class="white-container photo-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small" label-position="left" style="margin-top:20px">
      <el-form-item label="活动标题" prop="name" style="width: 460px">
        {{ form.name }}
      </el-form-item>
      <el-form-item v-if="type === 1" label="活动照片链接" prop="linkToPicture">
        <el-input v-model="form.linkToPicture" placeholder="请输入活动链接" style="width: 360px;" />
      </el-form-item>
      <el-form-item v-if="type === 1" label="上传图片" class="upload-wrap" prop="photos">
        <UploadImage :url="Array.isArray(form.photos)&&form.photos.length && form.photos[0].url || ''" save-path="ua_activity/uastar/" title="照片封面" size-tips="1005px*565px" @upload="handleUploader" />
      </el-form-item>
      <el-form-item v-if="type !== 1" label="上传图片/视频">
        <div class="coupon-upload flex">
          <el-upload ref="uploader" class="uploader" action="" :on-change="handlePushUploader" :auto-upload="false" accept="image/*" multiple>
            <el-button slot="trigger" size="small">选择文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传到服务器</el-button>
          </el-upload>
          <div class="coupon_tip upload_tips" style="color:#BBBBBB;margin-left:10px">支持上传*.png、*.jpg，大小不超过5M</div>
        </div>
      </el-form-item>
      <div v-if="Array.isArray(form.photos)&&form.photos.length && type !== 1" class="image-list flex">
        <div v-for="(item,index) in form.photos" :key="index" class="image-item">
          <div class="img-wrap">
            <img :src="item.url" alt="">
            <div v-if="!item.isCoverPhoto" class="cover">封面</div>
            <div class="mask">
              <i class="el-icon-close close-icon" @click="remove(index)" />
              <div class="operation">
                <el-button type="text" style="display:block;color:#fff;text-decoration:underline;width:100%;" @click="onPreview(index)">查看图片</el-button>
                <el-button type="text" style="display:block;color:#fff;text-decoration:underline;margin-left:0;;width:100%;" @click="setCover(index)">设为封面</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!--图片预览-->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="list" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="goBack" />
  </div>
</template>
<script>
// import {mapActions, mapState} from "vuex";
import { ActivityPhoto } from '@/model/ActivityPhoto';
// import { getFileType } from '@/common/js/util'
import UploadImage from '@/components/UploadImage';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Dialog from '@/components/Dialog';

export default {
  components: { UploadImage, ElImageViewer, Dialog },
  data() {
    const checkPhotos = (rule, value, callback) => {
      if (Array.isArray(value) && value.length) {
        callback();
      } else {
        callback(new Error('请上传图片'));
      }
    };
    return {
      form: new ActivityPhoto(),
      name: '',
      type: undefined, // 用户获取详情
      objectType: undefined, // 用于区分专题还是ua
      showViewer: false,
      list: [],
      formDialogShow: false,
      information: {},
      fileList: [],
      rules: {
        linkToPicture: [
          { required: false, message: '请输入活动链接', trigger: 'blur' },
        ],
        checkPhotos: [
          { required: false, message: "请上传图片", trigger: "blur" },
          { validator: checkPhotos, trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    form: {
      handler(val) {
        if (val.photos && Array.isArray(val.photos)) {
          this.list = val.photos.map((item) => item.url);
          this.initList = val.photos.map((item) => item.url);
        }
      },
      deep: true,
    },
  },
  mounted() {
    const { query } = this.$route;
    this.id = Number(query.id);
    this.type = parseInt(query.type);
    this.objectType = parseInt(query.objectType);
    this.getHighlightMomentDetails();
  },
  methods: {
    handleUploader(url) {
      const arr = [{
        isCoverPhoto: 0,
        type: 0,
        objectId: this.id,
        url,
      }];
      this.form.photos = [].concat(arr);
    },
    getHighlightMomentDetails() {
      this.$Api.activity.getHighlightMomentDetails(this.objectType, this.id)
        .then((res) => {
          if (res) {
            this.form = new ActivityPhoto(res);
          }
        });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 高光时刻未设置封面 使第一张图成为封面
          if (!this.form.photos.some(item => item.isCoverPhoto === 0) && this.form.photos.length) {
            this.form.photos[0].isCoverPhoto = 0;
          }
          console.log(this.form.photos.some(item => item.isCoverPhoto === 0));
          console.log(this.form.photos, 999);
          this.form.photos = this.form.photos.map((item) => {
            if (item.id) delete item.id;
            return item;
          });
          console.log(this.form, this.id, this.objectType, '#####');
          if (this.type === 1) {
            this.$Api.activity.updateSpecialHighlightMoment({ ...this.form, objectId: this.id }).then(res => {
              this.$message.success('编辑成功');
              this.goBack();
            });
          } else {
            delete this.form.linkToPicture;
            this.$Api.activity.updateHighlightMoment({ ...this.form, objectId: this.id, objectType: this.objectType }).then((res) => {
              this.$message.success('编辑成功');
              this.goBack();
            });
          }
        } else {
          return false;
        }
      });
    },
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      // const isLt5M = file.size / 1024 / 1024 < 5
      // if (getFileType(file.raw.name) !== 'image') {
      //   this.errorList.push(`${file.raw.name}图片格式错误`)
      //   // this.$refs.uploader.clearFiles()
      //   return
      // }
      // } else if (!isLt5M) {
      //   this.$message.error('大小不能超过5M')
      //   this.errorList.push('fileName')
      //   this.$refs.uploader.clearFiles()
      //   return
      // }

      this.fileList.push(file.raw);
    },
    submitUpload() {
      const types = ['png', 'jpg', 'jpeg'];
      const savePath = this.objectType === 7 ? 'camp/imgaes/' : 'ua_activity/images/';
      const uploadPromise = this.type === 0
        ? this.$Api.uploadFile.uaStarUploadFiles(this.fileList, savePath, types, true)
        : this.$Api.uploadFile.uploadImageList(this.fileList, savePath, types, false);

      uploadPromise.then(data => {
        const { uploadSuccessList, uploadFailList } = data;
        this.$refs.uploader.clearFiles(); // 清空文件列表
        const tempArr = [];

        // 上传成功
        uploadSuccessList.map((item) => {
          const photo = {
            isCoverPhoto: 1,
            type: 0,
            objectId: this.id,
            objectType: this.objectType,
            url: item.describe,
          };
          tempArr.push(photo);
        });

        this.form.photos = [...this.form.photos, ...tempArr];
        this.fileList = [];

        // 上传失败
        if (uploadFailList.length) {
          let errMsg = '';
          uploadFailList.map((item) => {
            errMsg = errMsg + (`${item.name}上传失败，失败原因：${item.describe}<br />`);
          });
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message: errMsg,
          });
        }
      });
    },
    onPreview(index) {
      this.showViewer = true;
      const tempSrcList = [...this.initList];
      const temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempSrcList.shift());
      }
      this.list = tempSrcList.concat(temp);
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    remove(index) {
      const images = [...this.form.photos];
      images.splice(index, 1);
      this.form.photos = images;
    },
    setCover(_index) {
      this.form.photos.map((item, index) => {
        item.isCoverPhoto = index === _index ? 0 : 1;
      });
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃编辑，返回上级页面？`,
      };
    },
    goBack() {
      this.$router.back(-1);
    },

  },
};

</script>
<style lang="less" scoped>
.btns {
  align-items: center;
  justify-content: center;
}
</style>
<style lang="less">
.photo-edit {
  .upload-wrap {
    display: flex;
    flex-direction: column;
    .el-form-item__label {
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      color: #494949;
      margin-bottom: 20px;
    }
    .el-form-item__content {
      margin-left: unset !important;
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .image-list {
    flex-wrap: wrap;
    .image-item {
      width: 150px;
      height: 150px;
      text-align: center;
      margin-right: 10px;
      margin-bottom: 10px;
      .img-wrap {
        border: 1px dashed #e5e5e5;
        width: 100%;
        height: 100%;
        position: relative;
        &:hover {
          .mask {
            display: block;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .cover {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 24px;
          line-height: 24px;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 100;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          display: none;
          .close-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 20px;
            cursor: pointer;
          }
          .operation {
            width: 100%;
            height: auto;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>

